import { connect } from 'react-redux';
import { fetchGroups } from '../Channels/channelRoutines';
import {getActiveEvent, getActiveEventName, selectInviteeCountForEvent} from '../Events/selectors';
import { makeActiveUserCount, makeRegistrantCount } from '../../redux/usersSelectors';
import { makeModuleCounts } from './dashboardSelectors';
import { saveEventHeroImage, updateActiveModule, updateChannelsModule, updatePeerToPeerModule, updatePeerToPeerVideoChat } from '../Events/eventRoutines';
import { setActiveEvent } from '../../redux/ui/actions';
import { syncUsers, updateActiveUsers } from '../../sagas/routines/userRoutines';
import Dashboard from '../../Components/Dashboard';

function mapStateToProps(state) {
    return {
        active_event: getActiveEvent(state),
        active_modules: state.activeModules.primary,
        active_user_count: makeActiveUserCount(state),
        event_name: getActiveEventName(state),
        events: state.events.activeMaster,
        invitee_count: selectInviteeCountForEvent(state),
        registrant_count: makeRegistrantCount(state),
        isChannelsEnabled: state.activeModules.secondary.isChannelsEnabled,
        isPeerToPeerEnabled: state.activeModules.secondary.isPeerToPeerEnabled,
        isPeerToPeerVideoChatEnabled: state.activeModules.secondary.isPeerToPeerVideoChatEnabled,
        isProfilePicRequired: state.profile.isProfilePicRequired,
        moduleCounts: makeModuleCounts(state),
    };
}
const mapDispatchToProps = {
    fetchGroups,
    saveEventHeroImage,
    setActiveEvent,
    syncUsers,
    updateActiveModule,
    updateActiveUsers,
    updateChannelsModule,
    updatePeerToPeerModule,
    updatePeerToPeerVideoChat,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Dashboard);
